// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"110":"f9a8c6c5","706":"9870d433"}[chunkId] + ".js";
};